import React, { useContext } from "react";
import { RootStoreContext } from "../../../app/stores/rootStore";

const BrokerFilterInfo = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { getBrokerFilterInfo } = rootStore.reportStore;

  return (
    <div      
      dangerouslySetInnerHTML={{ __html: getBrokerFilterInfo() }}
    ></div>
  );
};

export default BrokerFilterInfo;
